import GetPaidPage from "@/features/get-paid/GetPaidPage";

export default function GetPaid() {
  return <GetPaidPage />;
}
